// extracted by mini-css-extract-plugin
export var container = "_f5-0";
export var content = "_f5-3";
export var customerTitle = "_f5-4";
export var empty = "_f5-5";
export var gray = "_f5-6";
export var header = "_f5-7";
export var info = "_f5-8";
export var loading = "_f5-2";
export var loadingCard = "_f5-9";
export var oneLine = "_f5-a";
export var personName = "_f5-e";
export var pillContainer = "_f5-b";
export var selected = "_f5-1";
export var text = "_f5-c";
export var twoLines = "_f5-d";
export var unread = "_f5-f";
export var unreadIndicator = "_f5-g";